import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { isMobile } from "react-device-detect";
import { Link } from "react-router-dom";
import { FONTS, ROUTES } from "../constants";
import { stateType } from "../state";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			height: isMobile ? "100px" : "150px",
			width: "100vw",
			backgroundImage:
				"linear-gradient(to right top, #000000, #0f0309, #160714, #190d1d, #171228, #141329, #11142a, #0d152b, #0f1223, #0e0e1b, #0b0a12, #060606)",
		},
		text: {
			color: "white",
			fontSize: "33px",
			fontFamily: FONTS,
			fontWeight: 200,
			justifyContent: "center",
			display: "flex",
			marginBottom: isMobile ? "10px" : "20px",
			paddingTop: "15px",
		},
		tryItButtonOut: {
			zIndex: 100,
			backgroundColor: "white",
			"&:hover": {
				backgroundColor: "rgba(255,255,255,0.9)",
			},
			transition: "0.2s",
			border: "solid",
			borderColor: "white",
			borderRadius: "10px",
			borderWidth: "2px",
			marginRight: isMobile ? "auto" : "50px",
			height: "50px",
			width: "170px",
			color: "black",
			textAlign: "center",
			fontFamily: FONTS,
			lineHeight: "50px",
			fontSize: "20px",
			cursor: "pointer",
			fontWeight: "bold",
		},

		getDemo: {
			zIndex: 100,
			backgroundColor: "rgba(0,0,0,0)",
			"&:hover": {
				backgroundColor: "rgba(0,0,0,0.2)",
			},
			transition: "0.2s",
			border: "solid",
			borderColor: "white",
			borderRadius: "10px",
			borderWidth: "2px",
			height: "50px",
			width: "170px",
			textAlign: "center",
			fontFamily: FONTS,
			lineHeight: "50px",
			fontSize: "20px",
			fontWeight: "bold",
			cursor: "pointer",
			color: "white",
		},

		buttonRow: {
			display: "flex",
			flexDirection: "row",
			justifyContent: "center",
		},
	})
);

export function BottomButtons({ state }: stateType) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<div className={classes.text}></div>
			<div className={classes.buttonRow}>
				<TryItButtonOutlined></TryItButtonOutlined>
			</div>
		</div>
	);
}

function TryItButtonOutlined() {
	const classes = useStyles();
	return (
		<Link to={ROUTES.data_ingestion} style={{ textDecoration: "none" }}>
			<div className={classes.tryItButtonOut}>TO DASHBOARD</div>
		</Link>
	);
}
